module.exports = __webpack_public_path__ + "img/zeigling6.92101f8e.jpg";